import React from "react";
import { useHistory } from "react-router-dom";

export default function CardWrap(props) {
  const { step } = props;
  const history = useHistory();

  return (
    <div className="p-2">
      <div className="row pl-2 pt-2">
        {step ? (
          <div className="container">
            <ol className="progress-meter">
              <li className={`progress-point ${step >= 1 ? "done" : "todo"}`}>
                Prijava
              </li>
              <li className={`progress-point ${step >= 2 ? "done" : "todo"}`}>
                Prodajna mjesta
              </li>
              <li className={`progress-point ${step >= 3 ? "done" : "todo"}`}>
                Cjenici
              </li>
              <li className={`progress-point ${step >= 4 ? "done" : "todo"}`}>
                Provjera podataka
              </li>
            </ol>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="card container-fluid p-0">
        {props.subtitle && (
          <div className="card-header card-wrap">
            <span>
              {props.subtitle}{" "}
              {props.entity != undefined ? `- ${props.entity}` : ""}
            </span>
            {props.backUrl ? (
              <button
                className="btn btn-sm btn-outline-secondary web-hidden"
                onClick={() => history.push(props.backUrl)}
                style={{ float: "right" }}
              >
                <span className="icon icon-cancel"></span>
              </button>
            ) : null}
          </div>
        )}

        <div className="card-body">{props.children}</div>
      </div>
    </div>
  );
}
